// The assembled registry of post-auth actions. Feature modules own their action
// definitions; this file only composes them and exposes the drain. Importing
// feature modules here (rather than the other way round) keeps the dependency
// direction cycle-free: features never import back into the registry.

import type {PostAuthAction} from './types';
import {drainPostAuthActions} from './queue';
import {redeemAccessCodeAction} from './redeem_access_code';
import {saveOnboardingAction} from 'iq-onboarding/post_auth';
import {submitInterviewExperienceAction} from 'iq-interview_experiences/post_auth';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- heterogeneous payload types across actions.
const POST_AUTH_ACTIONS: readonly PostAuthAction<any>[] = [
  saveOnboardingAction,
  submitInterviewExperienceAction,
  redeemAccessCodeAction,
];

/** Run every pending post-auth action against the freshly authenticated user. */
export function runPendingPostAuthActions(): Promise<void> {
  return drainPostAuthActions(POST_AUTH_ACTIONS);
}
